import { render, staticRenderFns } from "./LDialog.vue?vue&type=template&id=412039b1&scoped=true"
import script from "./LDialog.vue?vue&type=script&lang=js"
export * from "./LDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412039b1",
  null
  
)

export default component.exports